import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import update from 'react-addons-update'
import { polyglot } from '../../../index'
import { Panel } from '../../common/Panel/Panel'
import { Renderer } from '../../common/Renderer/Renderer'
import MyGraphics from '../../common/MyGraphics/MyGraphics'
import './style.css'

export default class Graphics extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      patientConsultationsData: [],
      weightData: [],
      heightData: [],
      cephalicPerimeterData: [],
      weightDataForChart: undefined,
      heightDataForChart: undefined,
      cephalicPerimeterDataForChart: undefined
    }
  }

  addData (type, data) {
    const curr = this.state[type]
    curr.push(data)
    this.setState({
      [type]: curr
    })
  }

  getDataFromRoutineConsultations (data) {
    if (data) {
      const orderedConsultations = {...data}
      Object.keys(orderedConsultations).forEach(key => {
        const consultation = orderedConsultations[key]
        if (consultation.hasOwnProperty('healthParameters')) {
          const healthParameters = consultation.healthParameters
          let height = healthParameters.length ? healthParameters.length : healthParameters.height
          const obj = {
            date: consultation.date,
            weight: healthParameters.weight,
            height: height,
            cephalicPerimeter: healthParameters.cephalicPerimeter
          }
          this.addData('patientConsultationsData', obj)
        }
      })
    }
  }

  componentWillMount () {
    const data = this.props.patientData
    if (data) {
      this.getDataFromRoutineConsultations(data.consultations)
      this.sortData()
      this.getWeightData()
      this.getHeightData()
      this.getCephalicPerimeterData()
    }
  }

  sortData () {
    if (this.state.patientConsultationsData) {
      const array = this.state.patientConsultationsData
      array.sort(function (a, b) {
        if (new Date(a.date) > new Date(b.date)) {
          return 1
        } else if (new Date(a.date) < new Date(b.date)) {
          return -1
        } return 0
      })
      this.setState({
        patientConsultationsData2: array
      })
    }
  }

  getWeightData () {
    let initialArray = this.state.weightData || []
    if (this.state.patientConsultationsData) {
      this.state.patientConsultationsData.forEach(consultation => {
        if (consultation.weight) {
          const object = {
            x: new Date(consultation.date).getTime(),
            y: Number(consultation.weight)
          }
          initialArray = update(initialArray, {$push: [object]})
        }
      })
    }
    this.setState({
      weightData: initialArray
    })
  }

  getHeightData () {
    let initialArray = this.state.heightData || []
    if (this.state.patientConsultationsData) {
      this.state.patientConsultationsData.forEach(consultation => {
        if (consultation.height) {
          const object = {
            x: new Date(consultation.date).getTime(),
            y: Number(consultation.height)
          }
          initialArray = update(initialArray, {$push: [object]})
        }
      })
    }
    this.setState({
      heightData: initialArray
    })
  }

  getCephalicPerimeterData () {
    let initialArray = this.state.cephalicPerimeterData || []
    if (this.state.patientConsultationsData) {
      this.state.patientConsultationsData.forEach(consultation => {
        if (consultation.cephalicPerimeter) {
          const object = {
            x: new Date(consultation.date).getTime(),
            y: Number(consultation.cephalicPerimeter)
          }
          initialArray = update(initialArray, {$push: [object]})
        }
      })
      this.setState({
        cephalicPerimeterData: initialArray
      })
    }
  }

  render () {
    return <div>
      <Panel heading={polyglot.t('staticFields.home.graphics.title')}>
        {this.state.heightData.length < 2 && this.state.weightData.length < 2 && this.state.cephalicPerimeterData.length < 2
          ? <div>{polyglot.t('staticFields.home.graphics.noData')}</div>
          : <Fragment>
            <Renderer noMessage data={this.state.heightData.length ? {} : undefined}>
              <div className='col-xs-12 graphic-window no-side-padding'>
                <MyGraphics height={600} title={'Title'} type={'date'} data={[
                  {title: 'height',
                    color: 'green',
                    noHover: false,
                    ignoreX: false,
                    type: 'lineMark',
                    xType: 'time',
                    isDifferentScale: true,
                    data: this.state.heightData
                  },
                  {title: 'cephalicPerimeter',
                    color: 'yellow',
                    noHover: false,
                    ignoreX: false,
                    type: 'lineMark',
                    xType: 'time',
                    isDifferentScale: true,
                    data: this.state.cephalicPerimeterData
                  },
                  {title: 'weight',
                    color: 'red',
                    noHover: false,
                    type: 'lineMark',
                    xType: 'time',
                    ignoreX: false,
                    isDifferentScale: true,
                    data: this.state.weightData
                  }
                ]} />
              </div>
            </Renderer>
          </Fragment>
        }
      </Panel>
    </div>
  }
}

Graphics.propTypes = {
  patientData: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/general/Home/Graphics.js